import React from "react"
import makeStyles from "@mui/styles/makeStyles"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import Button from "@mui/material/Button"
import { Link } from "react-router"
import {COLORS} from "../../utils"

const useStyles = makeStyles(() => ({
    dialog: {
        textAlign: "justify",
        color: COLORS.GREY_SEARCH,
        fontSize: 16,
        "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0,0,0,0.1)"
        }
    },
    rootDialogActions: {
        justifyContent: "space-between",
        padding: 15,
        marginBottom: 15
    },
	linkBlue: {
		color: COLORS.PRIMARY_COLOR,
		textDecoration: "none",
		paddingLeft: 10,
		textTransform: "uppercase",
		fontSize: "0.875rem"
	},
    title: {
        fontWeight: 500,
        fontSize: 17,
    },
    dialogTitle: {
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: 0,
    },
    dialogTitleLabel: {
        fontWeight: 500,
        marginTop: 5,
        fontSize: 20,
        lineHeight: "24px",
        width: 596
    }
}))

const ConnectedChangedModal = (props) => {
    const {
        open,
        section,
        onClose,
        disconnect
    } = props

    const classes = useStyles()
    const title = (section)?section.name:""
    const url = (section)?`/settings/resources/sections?redirect=${section.id}`:""

    return (
        <Dialog
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            className={classes.dialog}
        >
            <DialogTitle
                id="customized-dialog-title"
                onClose={onClose}
                classes={{root: classes.dialogTitle}}>
                <span className={classes.dialogTitleLabel}>Déconnecter la section réutilisable : {title} ?</span>
            </DialogTitle>
            <DialogContent>
                <p>
                    Cette section est connectée à une section réutilisable globale.
                </p>
                <p>
                    Pour modifier cette recette uniquement, vous devez déconnecter cette section réutilisable.
                    Elle ne recevra plus de mise à jour de la séction réutilisable globale.
                </p>
            </DialogContent>
            <DialogActions classes={{root: classes.rootDialogActions}}>
                <Link
                    className={classes.linkBlue}
                    color="primary"
                    target="_blank"
                    to={{pathname: url}}
                >
                    Voir la section réutilisable
                </Link>
                <Button
                    color="secondary"
                    type="submit"
                    onClick={disconnect}
                >
                    Déconnecter cette section
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConnectedChangedModal
